export default "__VITE_ASSET__Sg0lGQUR__"